<script setup lang="ts">
import { upgradeCardApi } from '@/api/pvp-card';
import { useUserStore } from '@/stores/modules/user';
import { computed, ref } from 'vue';
import { getUpgradeCost, getUpgradeCount } from '../services/tools';
import { usePvpCardProfileStore } from '../services/gameProfile';
import type { CardInventoryItem } from '@/types/pvp-card';
import SoulCurrency from './SoulCurrency.vue';
import CardInfo from './CardInfo.vue';
const props = withDefaults(defineProps<{
  showBtn?: boolean
}>(), {
  showBtn: false
})

const emits = defineEmits(['add-card', 'remove-card'])
const userStore = useUserStore()
const pvpCardProfileStore = usePvpCardProfileStore()
const card = ref<CardInventoryItem>({} as CardInventoryItem)
const showCard = ref(false)
function handleOpen(_card: CardInventoryItem) {
  card.value = _card
  showCard.value = true
}
defineExpose({
  handleOpen
})


async function upgradeCard(cardId: number) {
  if (!upgradeable.value)
    return ElMessage.error('升级条件未满足')
  const { duelCoin, needCount, level } = await upgradeCardApi(cardId)
  card.value.level = level
  card.value.count -= needCount
  userStore.consumables.duelCoin -= duelCoin
  pvpCardProfileStore.init()
}
const upgradeable = computed(() => {
  if (!card.value) return false
  return card.value.count >= getUpgradeCount(card.value.level) && userStore.consumables.duelCoin >= getUpgradeCost(card.value.level, card.value.grade)
})
function handleAddOrRemove(emit: 'add-card' | 'remove-card', card: any) {
  showCard.value = false
  emits(emit, card)
}


</script>
<template>
  <el-dialog v-model="showCard" width="100%" style="max-width: 500px">
    <card-info :card="card" :upgradeable="upgradeable" />
    <template #footer v-if="showBtn">
      <!-- 底部按钮 -->
      <div class="bottom-buttons">
        <el-button size="large" type="success" :disabled="!upgradeable" @click="upgradeCard(card.id)">
          <div>
            <div style="font-size: 12px;">升级</div>
            <div style="display: flex;font-weight: bold;font-size: 14px;margin-top:4px;">
              <div>{{ getUpgradeCost(card.level, card.grade) }}
                <SoulCurrency type="dust" size="18px" />
              </div>
            </div>
          </div>
        </el-button>
        <el-button v-if="card.level > 0 && !pvpCardProfileStore.isEquipped(card.id)" size="large" type="warning"
          @click="handleAddOrRemove('add-card', card)">使用</el-button>
        <el-button v-if="pvpCardProfileStore.isEquipped(card.id)" size="large" type="danger"
          @click="handleAddOrRemove('remove-card', card)">移除</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<style lang="scss" scoped>
/* 底部按钮 */
.bottom-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px;
}
</style>